"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _formik = require("formik");
var _SubmitButton = _interopRequireDefault(require("./SubmitButton"));
var _index = require("../index");
var _excluded = ["onCancel", "submitButtonText", "submitButtonStyle", "testingClass", "automationHook"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var cancelSubmitPropTypes = {
  /** Callback to be called if the Cancel button is clicked */
  onCancel: _propTypes["default"].func,
  /** Text on the submit button. Defaults to Update */
  submitButtonText: _propTypes["default"].string,
  /** Style of the submit button. Defaults to "primary". Secondary is not an option because the Cancel Button is secondary, and they should never be the same */
  submitButtonStyle: _propTypes["default"].oneOf(["primary", "tertiary", "danger"]),
  /** A class name used in test, that gets passed to the submit button */
  testingClass: _propTypes["default"].string,
  /** Hook used along with "cancel-button" and "submit-button" for automation testing */
  automationHook: _propTypes["default"].string
};
var CancelSubmitButtons = function CancelSubmitButtons(_ref) {
  var onCancel = _ref.onCancel,
    _ref$submitButtonText = _ref.submitButtonText,
    submitButtonText = _ref$submitButtonText === void 0 ? "Update" : _ref$submitButtonText,
    _ref$submitButtonStyl = _ref.submitButtonStyle,
    submitButtonStyle = _ref$submitButtonStyl === void 0 ? "primary" : _ref$submitButtonStyl,
    testingClass = _ref.testingClass,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useFormikContext = (0, _formik.useFormikContext)(),
    isSubmitting = _useFormikContext.isSubmitting;
  return /*#__PURE__*/_react["default"].createElement(_index.ButtonsContainer, rest, /*#__PURE__*/_react["default"].createElement(_index.SecondaryButton, {
    disabled: isSubmitting,
    onClick: onCancel,
    automationHook: (0, _automationHooks.getHook)(automationHook, "cancel-button")
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_SubmitButton["default"], _extends({
    buttonStyle: submitButtonStyle,
    className: testingClass
  }, (0, _automationHooks.hook)(automationHook, "submit-button")), submitButtonText));
};
CancelSubmitButtons.propTypes = cancelSubmitPropTypes;
var _default = exports["default"] = CancelSubmitButtons;